'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createRoutes;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _appBasePath = require('./constants/appBasePath');

var _appBasePath2 = _interopRequireDefault(_appBasePath);

var _Application = require('./routeHandlers/Application');

var _Application2 = _interopRequireDefault(_Application);

var _SignupFlow = require('./routeHandlers/SignupFlow');

var _SignupFlow2 = _interopRequireDefault(_SignupFlow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_SIGNUP_PATH = _appBasePath2.default + 'crm';

// This router is really basic because every page is managed by SignupFlow
// which assumes a /:step parameter which matches a key in the
// required step config object. Error pages and other non-specified
// routes are also managed by SignupFlow.
function createRoutes(appName) {
  return _react2.default.createElement(
    _reactRouter.Route,
    { name: appName, path: '/signup(-v2)', component: _Application2.default },
    _react2.default.createElement(_reactRouter.IndexRedirect, { to: DEFAULT_SIGNUP_PATH, component: _SignupFlow2.default }),
    _react2.default.createElement(_reactRouter.Route, {
      name: 'signup-flow-special',
      path: 'step/:step(/:subStep)',
      component: _SignupFlow2.default
    }),
    _react2.default.createElement(
      _reactRouter.Route,
      { name: 'signup-intent', path: ':signupIntent' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _SignupFlow2.default }),
      _react2.default.createElement(_reactRouter.Route, {
        name: 'signup-flow',
        path: ':portalid/step/:step(/:subStep)',
        component: _SignupFlow2.default
      }),
      _react2.default.createElement(_reactRouter.Route, {
        name: 'signup-flow',
        path: 'step/:step(/:subStep)',
        component: _SignupFlow2.default
      }),
      _react2.default.createElement(_reactRouter.Redirect, { from: '*', to: DEFAULT_SIGNUP_PATH })
    )
  );
}
module.exports = exports['default'];